import _ from 'lodash';

export class CaseUtil {
  static pascal = (valor: string): string => _.upperFirst(_.camelCase(valor));

  static camel = (valor: string): string => _.camelCase(valor);

  static kebab = (valor: string): string => _.kebabCase(valor);
}
